import { ParagraphComparePlugin } from './plugins/paragraph-compare';

if (typeof window !== 'undefined' && (window as any).AliTranslate) {
  (window as any).AliTranslate.registerPlugin('paragraph', ParagraphComparePlugin);
}
